/**
 * @description
 *	A list of ISO 3166-1 alpha-2 country codes.
 *
 * @see https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */
enum CountryCode {
	Argentina = "AR",
	Chile = "CL",
	Colombia = "CO",
	Ecuador = "EC",
	Panama = "PA",
	Peru = "PE",
	USA = "US"
}

export default CountryCode
